import React from 'react'

const UnknownUser = () => {
 return (
    <div className="flex items-center justify-center h-screen bg-gray-100">
      <div className="bg-white shadow-lg rounded-lg p-8 text-center max-w-md">
        <h1 className="text-2xl font-bold text-gray-800 mb-4">No User Found</h1>
        <p className="text-gray-700 mb-6">
          We couldn't find the user you're looking for. Please verify the details and try again.
          If you need help, feel free to reach out to our team.
        </p>
        <a
          href="https://aifinitelearning.com/#/landingpage"
          className="bg-blue-500 text-white px-6 py-2 rounded-md hover:bg-blue-600 transition"
        >
          Contact Us
        </a>
      </div>
    </div>
  );
}

export default UnknownUser
